/** Urlaubs-Header – dezente Sonnenuntergang-Atmosphäre, ohne ablenkende Animationen. */
export function VacationHeaderDecor() {
  return (
    <div
      className="eh-vacation-header-decor pointer-events-none absolute inset-0 z-[1] overflow-hidden"
      aria-hidden="true"
    >
      <div className="eh-vacation-header-decor__ambience" />
      <div className="eh-vacation-header-decor__horizon" />
    </div>
  );
}

/** Feiner Akzentstreifen über der Navigation – wie ein warmer Horizont. */
export function VacationNavDecor() {
  return (
    <div
      className="eh-vacation-nav-accent pointer-events-none absolute inset-x-0 top-0 z-[1] -translate-y-1/2"
      aria-hidden="true"
    />
  );
}
